import { gql } from '@apollo/client';

export const REVIEW_DSP_START_DELIVERY = gql`
  mutation ReviewDspStartDelivery($deliverAccountIdList: [Long!]!, $dspLevelReviewIdList: [Long!]!, $operatorName: String) {
    reviewDspStartDelivery(deliverAccountIdList: $deliverAccountIdList, dspLevelReviewIdList: $dspLevelReviewIdList, operatorName: $operatorName)
  }
`;

export interface ReviewDspStartDeliveryResponse {
  reviewDspStartDelivery: boolean;
}

export interface ReviewDspStartDeliveryInput {
  deliverAccountIdList: number[];
  dspLevelReviewIdList: number[];
  operatorName?: string | null;
}

